// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSimple_loader__6KBd0","spin":"LoadingSimple_spin__xnqlv"};